import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './works.styles'
import Paper from 'pobble-components/dist/paper'
import WorksHeader from './works-header/works-header.container'
import WorksTable from './works-table/works-table.container'
import WorkSkeleton from './work-skeleton/work-skeleton'
import AddWorksDialog from '../../../shared/add-works-dialog/add-works-dialog.container'

class Works extends Component {
  componentDidMount() {
    this.props.onMount(this.props.id)
  }
  render() {
    const { classes, student, id, pending } = this.props
    return (
      <Paper className={classes.container}>
        {!pending && (
          <Fragment>
            <WorksHeader />
            <WorksTable />
            {student && <AddWorksDialog id={id} />}
          </Fragment>
        )}
        {pending && (
          <Fragment>
            <WorkSkeleton />
          </Fragment>
        )}
      </Paper>
    )
  }
}

export default injectSheet(styles)(Works)
